const isOneClickEnabled = () => {
  // to prevent optimization by minification
  const isEnabled = process.env.REACT_APP_IS_ONE_CLICK_ENABLED;
  return isEnabled && isEnabled.repeat(1) === 'true';
};

export default isOneClickEnabled;
